import Typed from 'typed.js'

const options = {
  strings: ['Geef nu', 'Breng vrijheid'],
  typeSpeed: 200,
  backSpeed: 150,
  startDelay: 500,
  backDelay: 2500,
  loop: true
}

const typed = new Typed('.js-typed', options)
const typedMobile = new Typed('.js-typed-mobile', options)
